export default {
    methods: {
        /**
         * 数组的截取
         * @param arr 数组
         * @param start 截取的起始索引
         * @param length 截取的长度
         */
        subArray (arr, start, length) {
            let subArr = []
            let end = length + start
            for (let i = start, len = arr.length; i < len; i++) {
                if (i < end) {
                    subArr.push(arr[i])
                }
            }
            return subArr
        },
        /**
         * 去除首尾空格
         */
        trim (str) {
            return str && str.replace(/(^\s*)|(\s*$)/g, "")
        },
        /**
         * 滚动监听
         */
        onScroll (e) {
            console.log('滚动:%O', e)
            // e.target.style.height = e.target.scrollHeight + 'px'
            // 重置最大移动高度
            // this.maxMoveH = this.$refs.teatarea.offsetHeight
        },
    }
}